module.exports = __webpack_public_path__ + "static/media/bag-cleaning-icon.b5851096.svg";